import _ from 'lodash';
import {Component, Module} from 'app/decorators';

import Modal from 'app/services/modals';

import tpl from './analysis_warning.html';
import analysisTpl from './analysis.table.html';


class ActualAnalysisModal {

    constructor ($uibModalInstance, ngModel) {
        "ngInject"

        this.modal = $uibModalInstance;
        this.data = ngModel;
    }

    close () {
        this.modal.close();
    }
}


@Module({
    name: "app.directives.analysis.warning",
    modules: [
        Modal,
    ]
})
@Component({
    selector: 'blnd-analysis-warning',
    bindings: {
        ngModel: '=',
    },
    template: tpl,
})
export default class C {

    constructor (Modal) {
        "ngInject";
        this.Modal = Modal;
    }

    get hasValue() {
        return _.has(this.ngModel, 'is_analysis_valid');
    }

    openModal () {
        this.Modal.open({
            template: analysisTpl,
            controller: ActualAnalysisModal,
            size: 'small',
            resolve: {
                ngModel: () => this.ngModel,
            },
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/directives/analysis_warning.js